<template>
  <OtivoButton v-if="isItSuncorpstaff" colour="white" @click="triggerContactUsModal()">
    Contact staff financial services
  </OtivoButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useSessionStore } from '@/store/pinia/SessionStore'
import OtivoButton from '@/components/OtivoButton.vue'

// Composables
const store = useStore()
const sessionStore = useSessionStore()

// Reactive data
const showModal = ref<boolean>(false)

// Computed properties (replacing Vuex mapGetters)
const isItSuncorpstaff = computed(() => sessionStore.getWhitelabelData.identifier === 'SUNCORP')

// Methods
const toggleShowModal = (): void => {
  showModal.value = !showModal.value
}

const triggerContactUsModal = (): void => {
  store.commit('SUNCORP_CONTACT_US_MODAL', true)
  toggleShowModal()
}
</script>

<style scoped></style>
